export default "__VITE_ASSET__B2h2Dtca__"